import * as React from "react";
import { hot } from "react-hot-loader";
import { Link, NavLink } from 'react-router-dom';
import EnmUtils from '../../utils/EnmUtils';
import { IHeaderState } from './IHeaderState';
declare var configcustoms: any;
declare var libelle: any;


class Header extends React.Component<{}, IHeaderState> {

  private propsEnter:any;

  constructor(props: any) {
    super(props);

    this.propsEnter = props;

    // Init du state
    this.state = {
      ConnectedLogin: EnmUtils.getLoginConnectedUser()
    };

    this.logout = this.logout.bind(this);
  }

  public render() {
    return (
      <header id="header">
        <nav className="navbar navbar-expand-md navbar-light bg-white sticky-top">
          <NavLink to={configcustoms.Route.Home} className="navbar-brand font-weight-bold text-secondary">{libelle.header.title}</NavLink>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              <div className="headerDivider d-none d-md-block" />
            </ul>
            <ul className="navbar-nav ml-auto pt-2 pt-sm-0">
              {this.state.ConnectedLogin === "" &&
                <li className="nav-item mr-2">
                  <NavLink to={configcustoms.Route.MdpPerdu} className="nav-link text-secondary">{libelle.header.btnPasswordForgot}</NavLink>
                </li>
              }
              {this.state.ConnectedLogin === "" &&
                <li className="nav-item dropdown">
                  <a className="dropdown-toggle btn btn-primary" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {libelle.header.btnDropdown}&nbsp;
                </a>
                  <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <a href={configcustoms.UrlAuthent} className="dropdown-item text-secondary">{libelle.header.btnConnected}</a>
                    <Link to={configcustoms.Route.Inscription} className="dropdown-item text-secondary">{libelle.header.btnCreateUser}</Link>
                  </div>
                </li>
              }

              {this.state.ConnectedLogin !== "" &&
                <li className="nav-item">
                  <button onClick={this.logout} className="ml-3 btn btn-primary">{libelle.header.btnDisconnected}</button>
                </li>
              }
            </ul>
          </div>
        </nav>
      </header>
    );
  }

  private logout() {
    document.cookie = configcustoms.Other.CookieLogout;
    window.open(configcustoms.Other.UrlLogout, "_blank");
    if(document.location != null) {
      document.location.href = configcustoms.Other.AfterLogoutRedirect;
    }
  }
}

export default hot(module)(Header);
